<template>
  <section class="monthly-recap-card">
    <header>
      <div>
        <span class="eyebrow">REKAP BULANAN</span>
        <h3>Rekap tindakan medis per bulan</h3>
      </div>
    </header>

    <div class="monthly-recap-body">
      <modern-filter-bar embedded :show-timeseries="false" :show-search="false">
        <template #additional-filters>
          <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="date"
            persistent
            width="290px"
          >
            <template #activator="{ on, attrs }">
              <button type="button" class="modern-filter-selector" v-bind="attrs" v-on="on">
                <i class="far fa-calendar-alt" aria-hidden="true"></i>
                <span>{{ date }}</span>
              </button>
            </template>
            <v-date-picker v-model="date" scrollable type="month">
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal = false">Batal</v-btn>
              <v-btn text color="primary" @click="chooseMonth">Pilih</v-btn>
            </v-date-picker>
          </v-dialog>
          <button type="button" class="btn-modern-danger" @click="resetFilter">
            <i class="fas fa-redo-alt" aria-hidden="true"></i><span>Reset</span>
          </button>
        </template>
      </modern-filter-bar>

      <b-tabs content-class="pt-3">
        <b-tab title="Perawat" active>
          <TableNurse :month="month" :year="year" :monthName="monthName" />
        </b-tab>
        <b-tab title="Dokter">
          <TableDoctor :month="month" :year="year" :monthName="monthName" />
        </b-tab>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import TableNurse from "@/component/action-reports/Table.vue";
import TableDoctor from "@/component/action-reports/TableDoctor.vue";

export default {
  name: "MedicalActionMonthlyRecap",
  components: { TableNurse, TableDoctor },
  data() {
    return {
      date: moment().format("YYYY-MM"),
      modal: false,
      month: moment().format("MM"),
      year: moment().format("YYYY"),
      monthName: moment().locale("id").format("MMMM"),
    };
  },
  mounted() {
    this.$nextTick(this.refreshTables);
  },
  methods: {
    refreshTables() {
      this.$root.$emit("paginateNurseRecapt", this.month, this.year, this.monthName);
      this.$root.$emit("paginateDoctorRecapt", this.month, this.year, this.monthName);
    },
    applyDate() {
      const selected = moment(this.date, "YYYY-MM");
      this.month = selected.format("MM");
      this.year = selected.format("YYYY");
      this.monthName = selected.locale("id").format("MMMM");
      this.refreshTables();
    },
    chooseMonth() {
      if (!this.date) return;
      this.$refs.dialog.save(this.date);
      this.applyDate();
    },
    resetFilter() {
      this.date = moment().format("YYYY-MM");
      this.applyDate();
    },
  },
};
</script>

<style scoped>
.monthly-recap-card{background:#fff;border:1px solid #dfe8ee;border-radius:15px;box-shadow:0 5px 18px rgba(35,60,75,.05);overflow:hidden}.monthly-recap-card>header{padding:17px 19px;border-bottom:1px solid #e6edf2}.eyebrow{font-size:10px;color:#10958e;font-weight:800;letter-spacing:.1em}.monthly-recap-card h3{font-size:17px;margin:3px 0 0}.monthly-recap-body{padding:16px 19px 19px}
</style>
